import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import cartIcon from '../../../../images/icons/bag.svg';
import styles from './Bucket.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

class Bucket extends Component {
  render() {
    const {
      openCart, lineItemsCount, innerRef, blackBackground, sticky,
    } = this.props;

    return (
      <ClickableDiv
        className={cx(styles.bucket, !sticky && blackBackground ? styles['black-background'] : null)}
        onClick={openCart}
        ref={innerRef}
      >
        <img src={cartIcon} alt="" />
        <div className={styles['item-count']}>{lineItemsCount}</div>
      </ClickableDiv>
    );
  }
}

Bucket.propTypes = {
  innerRef: PropTypes.shape({}).isRequired,
  lineItemsCount: PropTypes.number.isRequired,
  openCart: PropTypes.func.isRequired,
  blackBackground: PropTypes.bool,
  sticky: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <Bucket innerRef={ref} {...props} />);
